<template>
  <div
    class="dropdown"
    ref="dropdown"
    @click="open = !open"
    v-click-away="close"
  >
    <button class="navbar__section">
      <img
        class="navbar__icon"
        :src="myProfile.profilePicture"
        :alt="
          $t('accessibility.ALT_PROFILE_PIC', { name: myProfile.firstName })
        "
      >
      <p
        id="navbar__user_name"
        class="navbar__section_text"
      >
        {{ myProfile.firstName }}
      </p>
      <Icon
        id="dropdown__icon"
        class="icon__90"
        name="goto"
        :fills="['#fff']"
      />
    </button>
    <section
      class="dropdown-menu"
      :class="{ open: open }"
    >
      <a
        class="dropdown-menu__item"
        v-if="myProfile.isDirektUser"
        :href="direktUrl"
      >
        <Icon
          class="navbar__icon"
          name="direkt"
          :fills="['#48738e']"
        />
        <p class="nav-icon-text text-dropdown">{{ $t("general.DIREKT") }}</p>
      </a>
      <a
        class="dropdown-menu__item"
        v-if="myProfile.isModOrAdmin"
        :href="modUrl"
      >
        <Icon
          class="navbar__icon"
          name="moderator"
          :fills="['#48738e']"
        />
        <p class="nav-icon-text text-dropdown">
          {{ $t("general.MODERATOR") }}
        </p>
      </a>
      <button
        class="dropdown-menu__item"
        @click="$emit('logOut')"
      >
        <Icon
          class="navbar__icon"
          name="logout"
          :fills="['#48738e']"
        />
        <p class="nav-icon-text text-dropdown">
          {{ $t("general.LOGOUT") }}
        </p>
      </button>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import clickAway from "@/directives/clickAway";
import Icon from "@/components/global/Icon.vue";

export default {
  name: "DropDown",
  components: {
    Icon,
  },
  data() {
    return {
      open: false,
    };
  },
  directives: {
    clickAway,
  },
  computed: {
    ...mapGetters(["myProfile"]),
    direktUrl() {
      return process.env.VUE_APP_DIREKT_ROUTE;
    },
    modUrl() {
      return process.env.VUE_APP_MOD_ROUTE;
    },
  },
  methods: {
    close() {
      this.open = false;
    },
    emitLogOut() {
      this.$emit("logOut");
    },
  },
};
</script>
